import { useDispatch } from "react-redux";
import useFetch from "./hooks/useFetch";
import CreateRoutes from "./routes";
import { getSiteSetting } from "./services/siteSettingService";
import { getSettings } from "./redux/slice/settingsSlice";
import { useLocation } from "react-router-dom";
import { SocketProvider } from "./providers/SocketContext";
import { HelmetProvider } from "react-helmet-async";
import { BannerProvider } from "./providers/BannerProviders";
import { useEffect } from "react";
import { verifyAuth } from "./redux/slice/authSlice";
import { useSelector } from "react-redux";

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { session } = useSelector((state) => state?.authProvider);

  useFetch({
    dependencies: ["siteSetting"],
    fetchFunction: async () => {
      const res = await getSiteSetting();
      dispatch(getSettings(res?.data));
      console.log(res?.data, "siteSettingList1");

      return res?.data;
    },
  });

  useEffect(() => {
    dispatch(verifyAuth());
  }, [location.pathname, session?.status]);

  return (
    <HelmetProvider>
      {/* <BannerProvider> */}
      {/* <SocketProvider> */}
      <CreateRoutes />
      {/* </SocketProvider> */}
      {/* </BannerProvider> */}
    </HelmetProvider>
  );
}

export default App;
